<template>
  <header>
    <div class="header--width">
      <div class="header-actions">
        <div class="header-actions-nav">
          <roe-navigation-menu
            :num="num"
            :save-action="saveAction"
            :change-route="changeRoute"
          >
          </roe-navigation-menu>
          <h3>{{ title }}</h3>
        </div>

        <div class="header-actions-btn-wrap">
          <button @click="onClose" class="btn-link">Introduction</button>
          <button class="btn-secondary" @click="onPrevious()">Previous</button>
          <button
            class="btn-primary"
            v-if="!currentStep.disableNextAction"
            :disabled="isParticipantsLoading"
            @click="onNext()"
          >
            Next
          </button>
        </div>
      </div>
      <slot :change-route="changeRoute"></slot>
      <FlashMessage :position="flashMessagePosition"></FlashMessage>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import {
  SHOW_FORM_ERRORS,
  HIDE_FORM_ERRORS,
  SET_CURRENT_STEP
} from "@/store/mutations.type";
import RoeNavigationMenu from "./NavigationMenu";
import { GO_NEXT_STEP, GO_STEP, GO_PREVIOUS_STEP } from "@/store/actions.type";

export default {
  name: "RoeWizardHeader",
  components: { RoeNavigationMenu },
  props: {
    title: {
      type: String
    },
    num: {
      type: Number,
      required: false
    },
    saveAction: {
      type: Function,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      "invalidForm",
      "isParticipantsLoading",
      "steps",
      "currentStep",
      "errorMessage",
      "flashMessagePosition",
      "stepByStepName",
      "warningMessage",
      "flashErrorMessage"
    ])
  },
  watch: {
    warningMessage: function(value) {
      if (value)
        this.flashMessage.warning({
          title: "Warning",
          message: value,
          time: 0
        });
    },
    flashErrorMessage: function(value) {
      if (value)
        this.flashMessage.error({
          title: "Error",
          message: value,
          time: 0
        });
    }
  },
  mounted() {
    this.setCurrentStep();
  },
  methods: {
    onPrevious() {
      if (this.invalidForm && this.$store.getters.isNextStepsCompleted) {
        this.$store.commit(SHOW_FORM_ERRORS);
        this.flashMessage.error({ title: "Error", message: this.errorMessage });
      } else {
        this.$store.dispatch(GO_PREVIOUS_STEP);
        this.changeRoute();
        this.$store.commit(HIDE_FORM_ERRORS);
      }
    },
    onClose() {
      this.$store.dispatch(GO_STEP, this.steps[0]);
      this.$store.commit(HIDE_FORM_ERRORS);
      this.changeRoute();
    },
    onNext() {
      if (this.invalidForm) {
        this.$store.commit(SHOW_FORM_ERRORS);
        this.flashMessage.error({ title: "Error", message: this.errorMessage });
      } else {
        if (
          this.$store.getters.canGoToStep(this.steps[this.currentStep.id + 1])
        ) {
          this.$store.dispatch(GO_NEXT_STEP);
          if (this.saveAction) this.saveAction();
          this.changeRoute();
        } else {
          this.flashMessage.error({
            title: "Error",
            message: this.errorMessage
          });
        }
      }
    },
    changeRoute() {
      this.$router.push({
        name: this.currentStep.name,
        params: {
          id: this.$route.params.id,
          step: this.currentStep.step
        }
      });
    },
    setCurrentStep() {
      let stepName =
        this.$router.currentRoute.params.step || this.$router.currentRoute.name;
      this.$store.commit(SET_CURRENT_STEP, this.stepByStepName(stepName));
    }
  }
};
</script>
